import React from 'react';
import { ListItem } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';

const pt = PropTypes;

const SalientIconItem = (props) => {
  const { iconData } = props;
  const { text, icon: IconComponent } = iconData;

  // eslint-disable-next-line max-len
  const containerClasses = 'sui-list-none !sui-p-0 sui-text-base sui-leading-normal sui-font-regular sui-flex sui-flex-row sui-items-center sui-w-full sm:sui-w-40 lg:sui-w-full';

  return (
    <ListItem className={containerClasses}>
      <div className="sui-w-8 sui-h-8 sui-flex-shrink-0 sui-flex sui-items-center sui-justify-center">
        <IconComponent
          className="sui-w-full sui-h-full"
          style={{
            width: '32px',
            height: '32px',
            maxWidth: '32px',
            maxHeight: '32px',
            display: 'block'
          }}
          aria-label={text}
        />
      </div>
      <span className="sui-ml-2 sui-text-wrap sui-line-clamp-2">{text}</span>
    </ListItem>
  );
};

SalientIconItem.displayName = 'SalientIconItem';

SalientIconItem.propTypes = {
  // Icon data object containing text and icon component
  iconData: pt.shape({
    text: pt.string.isRequired,
    // The icon should be a function/component rather than an element
    icon: pt.oneOfType([pt.func, pt.object]).isRequired
  }).isRequired,
};

export { SalientIconItem };
